export interface Step2Data {
  maiorTitulacao: string;
  nomeCursoTitulacao: string;
  instituicaoTitulacao: string;
  mesTitulacao: string;
  anoTitulacao: string;
  nomeCursoAndamento: string;
  periodoMatricula: string;
  grandeAreaConhecimento: string;
  subAreaConhecimento: string;
  anoMatriculaAtual: string;
  municipioCurso: string;
  ufCurso: string;
}

export const validateStep2 = (data: Step2Data): Partial<Step2Data> => {
  const errors: Partial<Step2Data> = {};

  if (!data.maiorTitulacao)
    errors.maiorTitulacao = "Maior titulação é obrigatória";
  if (!data.nomeCursoTitulacao.trim())
    errors.nomeCursoTitulacao = "Nome do curso é obrigatório";
  if (!data.instituicaoTitulacao.trim())
    errors.instituicaoTitulacao = "Instituição é obrigatória";
  if (!data.mesTitulacao)
    errors.mesTitulacao = "Mês de titulação é obrigatório";
  if (!data.anoTitulacao)
    errors.anoTitulacao = "Ano de titulação é obrigatório";

  return errors;
};
